// Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import banner from '../assets/img/vector/proyectos.svg';
import Section from '../layout/Section';
import proyectos from '../assets/data/proyectos.json';
import SectionContainer from '../subcomponents/SectionContainer';
import ImageText from '../subcomponents/ImageText';

class Proyectos extends Component {
  componentDidMount() {
    document.title = 'Casos de Éxito - Insacom';
    /* eslint-disable */
    $.HSCore.components.HSCubeportfolio.init('.cbp');
  }
  render() {
    return (
      <Section no-contact>
        <SectionContainer grey paddingTop={40} paddingBottom={'0px'}>
          <ImageText
            image={banner}
            title="Casos de Éxito"
            description="Estos son algunos de nuestros proyectos que hemos desarrollado para nuestros clientes."></ImageText>
        </SectionContainer>
        <SectionContainer>
          <div className="container">
            <ul id="filterControls" className="d-block list-inline text-center g-mb-30">
              <li
                className="list-inline-item cbp-filter-item cbp-filter-item-active g-brd-around g-brd-gray-light-v4 g-brd-primary--active g-color-gray-dark-v4 g-color-primary--hover g-color-primary--active rounded g-transition-0_3 g-px-20 g-py-7 mb-2"
                role="button"
                data-filter="*">
                Todo
              </li>
              <li
                className="list-inline-item cbp-filter-item g-brd-around g-brd-gray-light-v4 g-brd-primary--active g-color-gray-dark-v4 g-color-primary--hover g-color-primary--active rounded g-transition-0_3 g-px-20 g-py-7 mb-2"
                role="button"
                data-filter=".desarrollo">
                Desarrollo de Software
              </li>
              <li
                className="list-inline-item cbp-filter-item g-brd-around g-brd-gray-light-v4 g-brd-primary--active g-color-gray-dark-v4 g-color-primary--hover g-color-primary--active rounded g-transition-0_3 g-px-20 g-py-7 mb-2"
                role="button"
                data-filter=".camaras">
                Videovigilancia IP
              </li>
              <li
                className="list-inline-item cbp-filter-item g-brd-around g-brd-gray-light-v4 g-brd-primary--active g-color-gray-dark-v4 g-color-primary--hover g-color-primary--active rounded g-transition-0_3 g-px-20 g-py-7 mb-2"
                role="button"
                data-filter=".redes">
                Infraestructura de Red
              </li>
            </ul>
            <div
              className="cbp"
              data-controls="#filterControls"
              data-animation="quicksand"
              data-x-gap="30"
              data-y-gap="30"
              data-media-queries='[
                            {"width": 1500, "cols": 3},
                            {"width": 1100, "cols": 3},
                            {"width": 800, "cols": 3},
                            {"width": 480, "cols": 1},
                            {"width": 300, "cols": 1}
                        ]'>
              {proyectos.map((proyecto, key) => (
                <div key={key} className={proyecto.categoria + ' cbp-item identity'}>
                  <Link to={'/proyectos/' + proyecto.slug}>
                    <div className="u-block-hover g-parent">
                      <img
                        className="img-fluid g-transform-scale-1_1--parent-hover g-transition-0_5 g-transition--ease-in-out"
                        src={require('../assets/img/proyectos' + proyecto.img)}
                        alt="Preview"
                      />
                      <div className="d-flex w-100 h-100 g-bg-black-opacity-0_6 opacity-0 g-opacity-1--parent-hover g-pos-abs g-top-0 g-left-0 g-transition-0_3 g-transition--ease-in u-block-hover__additional--fade u-block-hover__additional--fade-in g-pa-20">
                        <ul className="align-items-end flex-column list-inline mt-auto ml-auto mb-0">
                          <li className="list-inline-item">
                            <i className="icon-communication-017 u-line-icon-pro"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      style={{ minHeight: '120px' }}
                      className="u-shadow-v19 g-bg-white text-center g-pa-25 mb-1">
                      <h3 className="h5 g-color-black g-font-size-16 g-font-weight-700 mb-1">
                        {proyecto.name}
                      </h3>
                      <p className="mb-0 g-color-gray-dark-v4 g-font-size-14">{proyecto.desc}</p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </SectionContainer>
      </Section>
    );
  }
}

export default Proyectos;



// WEBPACK FOOTER //
// ./src/sections/Proyectos.js